import { render, staticRenderFns } from "./StaffMainPage.vue?vue&type=template&id=df3d1ac4&scoped=true"
import script from "./StaffMainPage.vue?vue&type=script&lang=js"
export * from "./StaffMainPage.vue?vue&type=script&lang=js"
import style0 from "./StaffMainPage.vue?vue&type=style&index=0&id=df3d1ac4&prod&scoped=true&lang=css"
import style1 from "./StaffMainPage.vue?vue&type=style&index=1&id=df3d1ac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3d1ac4",
  null
  
)

export default component.exports